import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { Query } from '@Types/Base';
import type { ModalId } from '@Stores/ModalWindows/typings';

export interface TranslationParams {
  lang: string;
  country: string;
  modalId: ModalId;
}

async function getModalWindowTranslation(params: TranslationParams, request: Query) {
  const url = '/localizer/get-modal-window';
  const res = await Api.queryProxi<ApiResponse<any>>(
    url,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
    request,
  );

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getModalWindowTranslation;
